import Image from 'next/image';

import { Box, Button, Divider, Heading, Modal, Paragraph } from '@zillow/constellation-10';

import { RentalManagerUserTrackingEvent } from '@zg-rentals/ts-rental-manager-api-beta-client';
import { useRentalManagerUserTrackingWebApiHandler_event } from '@zg-rentals/ts-rental-manager-api-beta-client-react-query';

import { EXTERNAL_ROUTES } from '../../../constants/urls';

import PaymentsAggregatePageModalGraphic from '../../../assets/PaymentsAggregatePageModalGraphic.svg';

type Props = {
  onClose: () => void;
  paymentsAggregatePageUrl: string;
  onAcknowledge?: () => void;
};

const PaymentsAggregateViewModal = ({ onClose }: Props) => {
  const { mutate: trackEvent } = useRentalManagerUserTrackingWebApiHandler_event();

  const handleOnClose = (goToPaymentsAggregatePage = false) => {
    trackEvent({
      getParams: {
        trackingEvent: RentalManagerUserTrackingEvent.OPEN_PAYMENTS_AGGREGATED_VIEW_MODAL,
      },
    });

    if (goToPaymentsAggregatePage) {
      window.location.href = EXTERNAL_ROUTES.PAYMENTS_AGGREGATE_PAGE;
    } else {
      onClose();
    }
  };

  return (
    <Modal.Root open={true} size={{ base: 'fullScreen', md: 'md' }} onOpenChange={(open) => !open && handleOnClose()}>
      <Modal.Portal>
        <Modal.Backdrop>
          <Modal.Content css={{ paddingBlockStart: '0 !important' }}>
            <Modal.Body css={{ padding: '0 !important' }}>
              <Box>
                <Box
                  css={{
                    display: 'flex',
                    justifyContent: 'center',
                    marginBottom: '800',
                    borderRadius: '{radii.obj.soft} {radii.obj.soft} 0 0',
                    backgroundColor: 'bg.accent.green.soft',
                  }}
                >
                  <Image alt="Neighborhood" src={PaymentsAggregatePageModalGraphic} width={956} height={444} />
                </Box>
                <Box
                  css={{
                    display: 'flex',
                    justifyContent: 'center',
                    flexDirection: 'column',
                    gap: '400',
                    paddingInline: '600',
                    marginBottom: '800',
                  }}
                >
                  <Heading level={2} textStyle="heading-sm">
                    All your rent payments, all in one place
                  </Heading>

                  <Paragraph>
                    Track income across all your properties, quickly see who’s paid, and send reminders to those who
                    haven’t— all from one easy-to-scan page.
                  </Paragraph>
                </Box>
              </Box>
            </Modal.Body>
            <Divider />
            <Modal.Footer css={{ display: 'flex', justifyContent: 'flex-end', paddingInline: '400' }}>
              <Button tone="brand" emphasis="filled" onClick={() => handleOnClose(true)}>
                See what’s new
              </Button>
            </Modal.Footer>
            <Modal.CloseButton />
          </Modal.Content>
        </Modal.Backdrop>
      </Modal.Portal>
    </Modal.Root>
  );
};

export default PaymentsAggregateViewModal;
